const Style = {
    row: 'mb-6 flex w-full items-center gap-1.5',
    chip: `flex h-9 min-w-0 items-center justify-center gap-2 overflow-hidden rounded-full
        px-3 transition-all duration-300`,
    chipActive: 'bg-primary-600 text-white shadow-sm',
    chipDone: 'bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300',
    chipIdle: 'bg-surface-elevated text-text-muted',
    label: 'min-w-0 truncate font-medium leading-none',
    labelActive: 'text-sm',
    labelIdle: 'text-xs',
    link: 'flex min-w-0 items-center justify-center gap-2 text-inherit no-underline',
};

export default Style;
